// firebaseConfig.js
import { initializeApp } from "firebase/app";
import { getFirestore } from "firebase/firestore";
import { getAuth } from "firebase/auth";
import { getStorage } from "firebase/storage";

const firebaseConfig = {
  apiKey: "AIzaSyB-QzRmhCuT5zTHbhcYY9Ef7P-CFMLoJys",
  authDomain: "loyalitysystem-d564d.firebaseapp.com",
  projectId: "loyalitysystem-d564d",
  storageBucket: "loyalitysystem-d564d.firebasestorage.app", // ✅ your bucket
  messagingSenderId: "872283809383",
  appId: "1:872283809383:web:85e71a05dd94d799b416c2",
  measurementId: "G-TKVMZZTYKL"
};

const app = initializeApp(firebaseConfig);
const db = getFirestore(app);
const auth = getAuth(app);
const storage = getStorage(app);

export { db, auth, storage };